import React, { createContext, useContext, useEffect, useMemo, useState, } from 'react';
var UserInfoContext = createContext([{}, function () { }]);
export var UserInfoProvider = function (_a) {
    var children = _a.children, initialUserInfo = _a.userInfo;
    // TODO[DEP-1286]: Use UserInfo interface from packages/next/src/types.ts
    var _b = useState(initialUserInfo), userInfo = _b[0], setUserInfo = _b[1];
    // Update user info in state when new props load (i.e. on page navigation)
    useEffect(function () {
        setUserInfo(initialUserInfo);
    }, [initialUserInfo]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: useExhaustiveDependencies
    var userInfoPropsContextValue = useMemo(function () { return [userInfo, setUserInfo]; }, [userInfo, setUserInfo]);
    return (React.createElement(UserInfoContext.Provider, { value: userInfoPropsContextValue }, children));
};
export function useUserInfo() {
    return useContext(UserInfoContext);
}
